import { Button, Tooltip } from "@dit/core-frontend"
import { CONTROLLED_TEXT_INSERTION_COMMAND, FOCUS_COMMAND } from "lexical"
import React from "react"
import { memo } from "react"
import { EmailIcon, TrackIcon, WikiIcon } from "@editor/theme/editorIcons"

export const MentionButtons = memo(({ activeEditor, buttonProps }) => {
  return (
    <>
      <Tooltip content="Упомянуть пользователя">
        <Button
          onClick={() => {
            activeEditor.focus()
            activeEditor.dispatchCommand(CONTROLLED_TEXT_INSERTION_COMMAND, " @")
          }}
          style={{ cursor: "pointer" }}
          {...buttonProps}
          kind="borderless"
        >
          <EmailIcon />
        </Button>
      </Tooltip>

      <Tooltip content="Ссылка на задачу">
        <Button
          onClick={() => {
            activeEditor.focus()
            activeEditor.dispatchCommand(CONTROLLED_TEXT_INSERTION_COMMAND, " #")
          }}
          style={{ cursor: "pointer" }}
          {...buttonProps}
          kind="borderless"
        >
          <TrackIcon />
        </Button>
      </Tooltip>

      <Tooltip content="Ссылка на страницу">
        <Button
          onClick={() => {
            activeEditor.focus()
            activeEditor.dispatchCommand(CONTROLLED_TEXT_INSERTION_COMMAND, " /")
          }}
          style={{ cursor: "pointer" }}
          {...buttonProps}
          kind="borderless"
        >
          <WikiIcon />
        </Button>
      </Tooltip>
    </>
  )
})

MentionButtons.displayName = "MentionButtons"
